module.exports = __webpack_public_path__ + "static/asteroid-1204168b914f797fa0590f5ef343b0be.jpg";